import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import VideoCard from "./VideoCard";
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import Paragraph from "../Paragraph";
import {filterHeadline, filterHTML} from "../../helpers/filters";
import './VideoCards.scss';

const GET_VIDEOCARDS = gql`
query paragraphById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentVideoCards {
          fieldVcardsSectionHeader {
            ... on FieldParagraphFieldVcardsSectionHeader {
              entity {
                ... on Paragraph {
                  ... on ParagraphInnerSectionHeader {
                    fieldTxtHeadline
                    fieldHtmlBody {
                      value
                      format
                      processed
                    }
                    fieldVarTextAlignment
                  }
                }
              }
            }
          }
          fieldVcardsSectionFooter {
            ... on FieldParagraphFieldVcardsSectionFooter {
              entity {
                ... on Paragraph {
                  ... on ParagraphInnerSectionFooter {
                    fieldTxtHeadline
                    fieldHtmlBody {
                      value
                      format
                      processed
                    }
                    fieldObjectCta {
                      targetRevisionId
                    }
                  }
                }
              }
            }
          }
          fieldVcardsSectionStyle {
            ... on FieldParagraphFieldVcardsSectionStyle {
                ${fieldObjectSectionStyle}
            }
          }
          fieldVideoCards {
            ... on FieldParagraphFieldVideoCards {
              entity {
                ... on Paragraph {
                  ... on ParagraphInnerVideoCard {
                    fieldTxtHeadline
                    fieldTxtSubTitle
                    fieldHtmlBody {
                      value
                      format
                      processed
                    }
                    fieldVarVideoLink {
                      ... on FieldParagraphFieldVarVideoLink {
                        title
                        url {
                          path
                          routed
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

const VideoCards = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <Query asyncMode query={GET_VIDEOCARDS} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            const header = field.fieldVcardsSectionHeader ? field.fieldVcardsSectionHeader.entity : null;
            const footer = field.fieldVcardsSectionFooter ? field.fieldVcardsSectionFooter.entity : null;

            const styles = fieldObjectSectionStyleCss(field.fieldVcardsSectionStyle);

            const videoCards = field.fieldVideoCards && field.fieldVideoCards.length ? field.fieldVideoCards : null;

            markComponentLoadedAs(id, true);

            return (
                <div className={`videoCards${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}

                    <div className="container videoCards__container">
                        {header && ((header.fieldTxtHeadline) || (header.fieldHtmlBody && header.fieldHtmlBody.processed)) && (
                            <div className="videoCards__header">
                                {header.fieldTxtHeadline && (
                                    // eslint-disable-next-line react/no-danger
                                    <h2 dangerouslySetInnerHTML={{__html: filterHeadline(header.fieldTxtHeadline)}} />
                                )}
                                {header.fieldHtmlBody && header.fieldHtmlBody.processed && (
                                    // eslint-disable-next-line react/no-danger
                                    <div dangerouslySetInnerHTML={{__html: filterHTML(header.fieldHtmlBody.processed)}}/>
                                )}
                            </div>
                        )}

                        {videoCards &&(
                            <div className="videoCards__cards">
                                {videoCards.filter(videoCard => videoCard.entity && videoCard.entity.fieldVarVideoLink && videoCard.entity.fieldVarVideoLink.url).map(videoCard => (
                                    <VideoCard {...videoCard.entity}/>
                                ))}
                            </div>
                        )}

                        {footer && ((footer.fieldTxtHeadline) || (footer.fieldObjectCta && footer.fieldObjectCta.length) || (footer.fieldHtmlBody && footer.fieldHtmlBody.processed)) && (
                            <div className="videoCards__footer">
                                {footer.fieldTxtHeadline && (
                                    // eslint-disable-next-line react/no-danger
                                    <h4 dangerouslySetInnerHTML={{__html: filterHeadline(footer.fieldTxtHeadline)}} />
                                )}
                                {footer.fieldHtmlBody && footer.fieldHtmlBody.processed && (
                                    // eslint-disable-next-line react/no-danger
                                    <div dangerouslySetInnerHTML={{__html: filterHTML(footer.fieldHtmlBody.processed)}}/>
                                )}
                                {footer.fieldObjectCta && footer.fieldObjectCta.map(component => (
                                    <Paragraph key={`${id}_${component.targetRevisionId}`}
                                               id={String(component.targetRevisionId)}
                                               handleLoadedComponents={handleLoadedComponents}/>
                                ))}
                            </div>
                        )}

                    </div>

                </div>
            );
        }}
    </Query>
);

VideoCards.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default VideoCards;



// WEBPACK FOOTER //
// ./frontend/components/VideoCards/VideoCards.jsx